// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F9J5U{display:flex;flex-direction:column;border-radius:8px;border:1px solid transparent;box-shadow:0px 4px 12px rgba(40,40,99,.06)}.F9J5U.Ran5y{background:#f3f5ff;border-color:#c3b3fc}.F9J5U.Ran5y .kR3FY{color:var(--button-primary, #6942f8)}.F9J5U.fEGz2{background:#fdf0f0;border-color:#f9d5d5}.F9J5U.fEGz2 .kR3FY{color:#eb7272}.F9J5U.KtA71{background:#fdf2dc;border-color:#fadea8}.F9J5U.KtA71 .kR3FY{color:#dd9306}.F9J5U.MYoCZ{box-shadow:none}.F9J5U.ouLYP{background:transparent;border:none;box-shadow:none}.Fziwh{display:flex;gap:12px;padding:12px;align-items:flex-start;text-align:start}.kR3FY{flex-shrink:0;display:flex;justify-content:center;align-self:center}.F9J5U:not(.MYoCZ) .kR3FY.VNpqY>svg{width:24px;height:24px}.F9J5U:not(.MYoCZ) .kR3FY.XflgY>svg{width:16px;height:16px}.I0SQ6{align-self:center;flex:1;min-width:0;overflow-wrap:anywhere}.o_M4y{flex-shrink:0;align-self:center;background:transparent;border:0;padding:0;cursor:pointer;color:#696992;display:inline-flex;align-items:center;justify-content:center;border-radius:4px}.o_M4y:hover{color:#282863}.o_M4y:focus-visible{outline:2px solid var(--button-primary, #6942f8);outline-offset:2px}.pBZfM{padding:0 12px 12px}.pBZfM.T4bSi{padding-left:42px}.XWbjj{margin:8px;color:#282863;font-family:"Lufga-Regular";font-weight:400}.XWbjj ul{font-size:var(--font-size-p3, 10px);line-height:var(--line-height-p3, 14px);letter-spacing:.02em;margin:0;padding-inline-start:15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"root": `F9J5U`,
	"info": `Ran5y`,
	"icon": `kR3FY`,
	"error": `fEGz2`,
	"warning": `KtA71`,
	"mobile": `MYoCZ`,
	"transparent": `ouLYP`,
	"main": `Fziwh`,
	"defaultIconSize": `VNpqY`,
	"smallIconSize": `XflgY`,
	"content": `I0SQ6`,
	"dismiss": `o_M4y`,
	"actionRow": `pBZfM`,
	"withIcon": `T4bSi`,
	"footer": `XWbjj`
};
export default ___CSS_LOADER_EXPORT___;
